import type { RemoteLeague } from '../shared/user-store-client';

export function hydrateMissingLeagueSaveStrings(remoteLeagues: Record<string, RemoteLeague>): void {
  for (const guid in remoteLeagues) {
    const remote = remoteLeagues[guid];
    const local = localStorage.getItem(guid);
    if (local === null || local.length === 0) {
      localStorage.setItem(guid, remote.saveString);
    }
  }
}
